type CsvValue = string | number;

// RFC 4180: quote fields containing commas, quotes, or newlines; double internal quotes
const csvField = (value: CsvValue): string => {
  const text = String(value);

  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export const csvDataUri = (rows: CsvValue[][]): string => {
  const csv = rows.map(row => row.map(csvField).join(',')).join('\n');

  return `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
};
